import React from "react";

interface WhatsAppIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const WhatsAppIcon: React.FC<WhatsAppIconProps> = ({
  size = 24,
  color = "white",
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 16 16"
    >
      <path
        d="M8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 9.2154 1.65797 10.353 2.22481 11.3329L2.35736 11.562L2.29661 11.8197C2.11609 12.5853 2.04527 12.9919 1.95175 13.5289C1.92189 13.7004 1.88972 13.8851 1.85092 14.0991C2.3447 13.9746 2.7832 13.8635 3.17531 13.7641C3.45389 13.6935 3.70905 13.6288 3.94398 13.5695L4.2202 13.4998L4.4615 13.6512C5.48655 14.2946 6.6988 14.6667 8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C6.54446 16 5.17807 15.6107 4.00119 14.9303C3.84481 14.9699 3.67969 15.0117 3.50516 15.056C2.86276 15.2188 2.09286 15.414 1.16171 15.6468L0.139694 15.9023L0.3463 14.8693C0.477716 14.2122 0.558156 13.754 0.629149 13.3497C0.71959 12.8345 0.794701 12.4067 0.940346 11.7662C0.340126 10.6433 0 9.36047 0 8Z"
        fill={color}
      />
      <path
        d="M6.05113 4.61362C5.89029 4.22732 5.72691 4.27959 5.60527 4.27353C5.48982 4.26779 5.35758 4.26657 5.22547 4.26657C5.09337 4.26657 4.87869 4.31615 4.69703 4.51446C4.51539 4.71279 4.00348 5.19207 4.00348 6.16713C4.00348 7.14219 4.71355 8.08419 4.81264 8.21641C4.91171 8.34863 6.20999 10.3496 8.19787 11.2077C8.67065 11.4118 9.03979 11.5337 9.32757 11.625C9.80231 11.7758 10.2343 11.7545 10.5758 11.7035C10.9565 11.6467 11.7482 11.2243 11.9133 10.7615C12.0785 10.2988 12.0785 9.90212 12.0289 9.81948C11.9794 9.73687 11.8473 9.68728 11.6491 9.58811C11.4509 9.48896 10.4767 9.00967 10.295 8.94358C10.1134 8.87748 9.98127 8.84443 9.84916 9.04275C9.71707 9.24105 9.33729 9.68728 9.22169 9.81948C9.10611 9.9517 8.99051 9.96824 8.79236 9.86907C8.59419 9.76992 7.95567 9.56071 7.19876 8.88581C6.60968 8.36055 6.21194 7.71175 6.09635 7.51343C5.98075 7.31511 6.08405 7.20788 6.18325 7.10913C6.27239 7.02038 6.38141 6.87776 6.48049 6.76207C6.57957 6.64639 6.6126 6.56375 6.67865 6.43155C6.74471 6.29933 6.71167 6.18365 6.66213 6.08449C6.61259 5.98533 6.21628 5.01025 6.05113 4.61362Z"
        fill={color}
      />
    </svg>
  );
};

export default WhatsAppIcon;
